export enum TravelOrderPaymentType {
  FlatLinehaul = "flat-linehaul",
  DryRun = "dry-run",
  AsapMoves = "asap-moves",
  Bonus = "bonus",
  CleanTruckFee = "clean-truck-fee",
  DetentionPay = "detention-pay",
  DisposalFee = "disposal-fee",
  HandLoadUnload = "hand-load-unload",
  InsideDelivery = "inside-delivery",
  LayoverCost = "layover-cost",
  LumperFee = "lumper-fee",
  PalletJack = "pallet-jack",
  ExtraMiles = "extra-miles",
  QuickPayFee = "quick-pay-fee",
  Redirection = "redirection",
  Reimbursement = "reimbursement",
  Scales = "scales",
  SignsPrintingDocs = "signs-printing",
  Damage = "damage",
  Weight = "weight",
}

export const TravelOrderPaymentTypeLabel: Record<TravelOrderPaymentType, string> = {
  [TravelOrderPaymentType.FlatLinehaul]: "Flat Linehaul",
  [TravelOrderPaymentType.DryRun]: "Dry Run",
  [TravelOrderPaymentType.AsapMoves]: "Asap Moves",
  [TravelOrderPaymentType.Bonus]: "Bonus",
  [TravelOrderPaymentType.CleanTruckFee]: "Clean Truck Fee",
  [TravelOrderPaymentType.DetentionPay]: "Detention Pay",
  [TravelOrderPaymentType.DisposalFee]: "Disposal Fee",
  [TravelOrderPaymentType.HandLoadUnload]: "Hand load / unload",
  [TravelOrderPaymentType.InsideDelivery]: "Inside delivery",
  [TravelOrderPaymentType.LayoverCost]: "Layover Cost",
  [TravelOrderPaymentType.LumperFee]: "Lumper Fee",
  [TravelOrderPaymentType.PalletJack]: "Pallet Jack",
  [TravelOrderPaymentType.ExtraMiles]: "Extra miles",
  [TravelOrderPaymentType.QuickPayFee]: "Quick Pay Fee",
  [TravelOrderPaymentType.Redirection]: "Redirection",
  [TravelOrderPaymentType.Reimbursement]: "Reimbursement",
  [TravelOrderPaymentType.Scales]: "Scales",
  [TravelOrderPaymentType.SignsPrintingDocs]: "Signs / Printing docs",
  [TravelOrderPaymentType.Damage]: "Damage",
  [TravelOrderPaymentType.Weight]: "Weight",
};

export enum TravelOrderPaymentStatus {
  New = "new",
  Paid = "paid",
  Canceled = "canceled",
  NoPaid = "noPaid",
}

export enum TravelOrderPaymentStatusLabel {
  paid = "Paid",
  noPaid = "No paid",
  new = "New",
  canceled = "Canceled",
}

export const MandatoryPaymentTypes = [TravelOrderPaymentType.FlatLinehaul, TravelOrderPaymentType.DryRun];
